/*api接口的统一出口*/
import home from './home'

// 导出接口
export default{
  home,
}